export default {
	aboutUs: "درباره‌ما",
	account: "حساب کاربری",
	action: "عملیات",
	activation: "فعال کردن",
	active: "فعال",
	activity: "فعالیت",
	add: "افزودن",
	address: "آدرس",
	admin: "مدیر",
	adminPanel: "پنل مدیریت",
	admins: "مدیران",
	all: "همه",
	amount: "مبلغ",
	and: "و",
	answer: "پاسخ",
	approved: "تایید شده",
	arithmetic: "حساب",
	attach: "انتصاب",
	basicPricing: "قیمت پایه",
	backHome: "بازگشت به صفحه اصلی",
	banner: "بنر",
	basic: "پایه",
	birthdate: "تاریخ تولد",
	bk: "باکلید",
	blocked: "مسدود",
	business: "کسب و کار",
	buy: "خرید",
	byOwner: "توسط شرکت هومان",
	cancel: "لغو",
	category: "دسته‌بندی",
	categories: "دسته‌بندی‌ها",
	change: "تغییر",
	choose: "انتخاب کنید",
	city: "شهر",
	code: "کد",
	color: "رنگ",
	comingSoon: "بزودی",
	comma: "،",
	company: "شرکت",
	comparePass: "تکرار کلمه عبور صحیح وارد نشده است",
	confirm: "تایید",
	contactUs: "تماس‌با‌ما",
	content: "محتوا",
	copyright: "تمامی حقوق این سایت متعلق به با کلید می‌باشد.",
	cost: "هزینه",
	count: "تعداد",
	create: "ساخت",
	credit: "اعتبار",
	currency: "واحد پول",
	current: "فعلی",
	daily: "روزانه",
	dashboard: "داشبورد",
	date: "تاریخ",
	day: "روز",
	default: "پیش فرض",
	depositedTo: "واریز شده به شماره حساب",
	description: "توضیحات",
	discount: "تخفیف",
	draft: "پیش‌نویس",
	duration: "مدت زمان",
	edit: "ویرایش",
	delete: "حذف",
	deleteConfirm: "از حذف این آیتم اطمینان دارید؟",
	device: "دستگاه",
	education: "تحصیلات",
	email: "ایمیل",
	end: "پایان",
	enter: "ورود",
	error: "خطا",
	expire: "انقضا",
	faq: "سوالات متداول",
	fax: "فکس",
	features: "امکانات",
	financial: "مالی",
	footer: "فوتر",
	force: "اجبار",
	forgotPassword: "رمز عبور خود را فراموش کردید؟",
	forum: "انجمن",
	from: "از",
	gateway: "درگاه پرداخت",
	gender: "جنسیت",
	getOtp: "دریافت رمز یکبار مصرف",
	gift: "هدیه",
	ha: "‌ها",
	harvest: "برداشت",
	have: "دارای",
	homePage: "صفحه‌اصلی",
	icon: "آیکن",
	image: "تصویر",
	imperfect: "ناقص",
	inactive: "غیر فعال",
	income: "درآمد",
	info: "اطلاعات",
	instagram: "اینستاگرام",
	internet: "اینترنت",
	invisible: "غیر قابل مشاهده",
	job: "شغل",
	jobs: "مشاغل",
	kilometer: "کیلومتر",
	key: "کلید",
	ladder: "نربان",
	ladderPricing: "قیمت نردبانی",
	last: "آخرین",
	lastName: "نام خانوادگی",
	latitude: "عرض جغرافیایی",
	link: "لینک",
	list: "لیست",
	login: "ورود به حساب کاربری",
	logo: "لوگو",
	logout: "خروج",
	longitude: "طول جغرافیایی",
	managment: "مدیریت",
	manual: "دستی",
	members: "اعضا",
	message: "پیام",
	meter: "متر",
	mobile: "موبایل",
	mode: "حالت",
	month: "ماه",
	more: "بیشتر",
	multiple: "چندگانه",
	name: "نام",
	nationalCode: "کد ملی",
	nearbyRadius: "شعاع نزدیک",
	neutral: "بدون اشتراک",
	new: "جدید",
	no: "خیر",
	normal: "معمولی",
	notAdmin: "شما دسترسی به پنل ادمین ندارید",
	notfound: "متأسفیم، چنین صفحه‌ای وجود ندارد.",
	notification: "اعلان",
	notifications: "اعلانات",
	number: "شماره",
	owner: "مالک",
	os: "سیستم عامل",
	pages: "صفحات",
	paid: "پرداخت شده",
	password: "کلمه عبور",
	passwordRecovery: "بازیابی کلمه عبور",
	pay: "پرداخت",
	pending: "در انتظار تایید",
	permission: "سطح دسترسی",
	permissions: "سطوح دسترسی",
	personal: "شخصی",
	phone: "تلفن",
	plan: "پلن",
	plans: "پلن‌ها",
	platform: "پلتفرم",
	post: "مطلب",
	posts: "مطالب",
	price: "قیمت",
	pricing: "قیمت گذاری",
	primitive: "اولیه",
	profile: "پروفایل",
	province: "استان",
	public: "عمومی",
	publish: "انتشار",
	published: "منتشر شده",
	question: "سوال",
	qty: "تعداد",
	read: "خوانده شده",
	reason: "علت",
	record: "ثبت",
	region: "منطقه",
	register: "ثبت نام",
	reject: "رد کردن",
	rejected: "رد شده",
	rejectionReason: "دلیل رد",
	repeat: "تکرار",
	report: "گزارش",
	required: "این فیلد الزامیست",
	resend: "ارسال مجدد",
	rial: "ریال",
	role: "نقش",
	roles: "نقش‌ها",
	row: "ردیف",
	request: "درخواست",
	search: "جستجو",
	security: "امنیت",
	serial: "سریال",
	settings: "تنظیمات",
	score: "امتیاز",
	scores: "امتیازات",
	shaba: "شبا",
	sharing: "اشتراک گذاری",
	show: "نمایش",
	site: "سایت",
	sms: "پیامک",
	sort: "مرتب سازی",
	special: "ویژه",
	start: "شروع",
	status: "وضعیت",
	statusConfirm: "از تغییر وضعیت این آیتم اطمینان دارید؟",
	subscriber: "مشترک",
	subscription: "اشتراک",
	summary: "خلاصه",
	subject: "موضوع",
	submit: "ارسال",
	successful: "موفق",
	successfully: "موفقیت آمیز",
	support: "پشتیبانی",
	suspend: "تعلیق",
	suspended: "معلق شده",
	symbol: "نماد",
	systematic: "سیستمی",
	tac: "قوانین و مقررات",
	tag: "برچسب",
	tags: "برچسب‌ها",
	telegram: "تلگرام",
	text: "متن",
	title: "عنوان",
	to: "به",
	toman: "تومان",
	trace: "رهگیری",
	transaction: "تراکنش",
	type: "نوع",
	unauthorized: "متأسفیم، شما به این صفحه دسترسی ندارید.",
	unlimited: "نامحدود",
	unpaid: "پرداخت نشده",
	unpublished: "منتشر نشده",
	unread: "خوانده نشده",
	unSuccessful: "ناموفق",
	update: "بروزرسانی",
	upload: "بارگذاری",
	user: "کاربر",
	username: "نام کاربری",
	users: "کاربران",
	untill: "تا",
	version: "نسخه",
	visible: "قابل مشاهده",
	visit: "بازدید",
	wallet: "کیف پول",
	warning: "هشدار",
	webDesign: "طراحی سایت",
	without: "بدون",
	workTime: "زمان کاری",
	y: "ی",
	yes: "بله",

	uploadErros: {
		size: "حجم فایل باید کمتر از 10 مگ باشد",
		extension: "فرمت تصویر معتبر نمی‌باشد",
	},
};
